import { defineStore } from 'pinia'
import { store } from '../index'
import axios from 'axios'
interface DictState {
  domain?: any
}

let isRefrish = false

export const useCommonStore = defineStore('common', {
  state: (): DictState => {
    return {
      domain: {}
    }
  },
  getters: {
    // 获取上传文件路径
    getBaseUrl: (state) => {
      const url = state.domain
        ? state.domain.baseUploadPath
        : JSON.parse(localStorage.getItem('domain')).baseUploadPath
      if (!url && !isRefrish) {
        state.setDomain()
        return state.getBaseUrl
      }
      return url
    },
    // 获取api接口路径
    getBaseUrlApi: (state) => {
      const url = state.domain.baseURL
      if (!url && !isRefrish) {
        state.setDomain()
        return state.getBaseUrlApi
      }
      return url
    },
    // 获取api接口路径
    getStoreUrlApi: (state) => {
      const url = state.domain.storeURL
      if (!url && !isRefrish) {
        state.setDomain()
        return state.getStoreUrlApi
      }
      return url
    },
    // 获取父级域名
    getDomainName: (state) => {
      const url = state.domain.domainName
      if (!url && !isRefrish) {
        state.setDomain()
        return state.getDomainName
      }
      return url
    },
    // 获取门户地址
    getCmsCn: (state) => {
      const url = state.domain.cmsConfig.cn.url
      if (!url && !isRefrish) {
        state.setDomain()
        return state.getCmsCn
      }
      return url
    },
    getCmsEn: (state) => {
      const url = state.domain.cmsConfig.en.url
      if (!url && !isRefrish) {
        state.setDomain()
        return state.getCmsEn
      }
      return url
    },
    // 获取客户端id
    getClientId: (state) => {
      const url = state.domain.clientId
      if (!url && !isRefrish) {
        state.setDomain()
        return state.getClientId
      }
      return url
    }
  },
  actions: {
    // 获取本地文件配置
    async setDomain() {
      let res
      if (!isRefrish) {
        axios({
          method: 'get',
          url: '/config.json'
        }).then((response) => {
          res = response
          isRefrish = false
          localStorage.setItem('domain', JSON.stringify(res.data))
          this.domain = res.data
        })
      }
      isRefrish = true
    }
  },
  persist: true
})

export const useCommon = () => {
  return useCommonStore(store)
}
